<template>
  <section class="pd-y-30">
    <div class="container" style="max-width: 600px !important">
      <div class="section-title">
        <h2>{{ comp.task }}</h2>
        <p>{{ comp.f1 }}</p>
      </div>
    </div>
    <div class="container mg-b-40">
      <div class="row">
        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
          v-for="(c, i) in types"
          :key="i"
          role="button"
        >
          <div class="card bg-dark ht-200 overflow-hidden">
            <router-link
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: {
                  id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0]
                    .id,
                  cid: c.id
                }
              }"
            >
              <img
                v-if="c.field1 != null && c.field1 != ''"
                class="card-img-top op-2"
                :src="`${c.field1}?w=400&h=250&mode=crop`"
              />
              <img
                v-else
                class="card-img-top op-1"
                src="assets/img/course-type.jpg"
              />
              <div
                class="card-img-overlay d-flex align-items-center text-center"
              >
                <div class="wd-100p">
                  <h4 class="card-title text-white">{{ c.s1 }}</h4>
                  <p class="card-text text-white">
                    Нийт {{ c.courseCount }} хичээл
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      types: []
    };
  },
  mounted() {
    this.loadTypes();
  },
  methods: {
    loadTypes() {
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "courseType"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.types;
          //console.log(res);
        }
      });
    }
  }
};
</script>

<style></style>
